var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.hideText ? _c("p", [_vm._v("Все файлы заявки")]) : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        class: { "btn btn-default": true, adjust_height: !_vm.hideText },
        attrs: { type: "button" },
        on: { click: _vm.openFilesModal },
      },
      [
        _c("i", { staticClass: "icon-fa icon-fa-file-image-o" }),
        _vm._v(" "),
        !_vm.hideText
          ? _c("span", [
              _vm._v("Показать файлы (" + _vm._s(_vm.files.length) + ")"),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }